import am4geodata_worldIndiaLow from "@amcharts/amcharts4-geodata/worldIndiaLow";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import { useEffect, useState } from "react";
import styles from "./CountryProfileChart.module.scss";

const CountryProfileChart = ({ mapData, loading }) => {
  const [chartData, setChartData] = useState("");

  useEffect(() => {
    setChartData([...mapData]);
  }, [mapData]);

  useEffect(() => {
    // Create chart instance
    const chart = am4core.create("chartdiv", am4maps.MapChart);
    chart.projection = new am4maps.projections.Miller();
    chart.zoomControl = new am4maps.ZoomControl();
    chart.zoomControl.align = "right";
    chart.zoomControl.marginRight = 15;
    chart.seriesContainer.draggable = true;
    chart.seriesContainer.resizable = false;

    let homeButton = new am4core.Button();
    homeButton.events.on("hit", function () {
      chart.goHome();
    });

    homeButton.icon = new am4core.Sprite();
    homeButton.padding(7, 5, 7, 5);
    homeButton.width = 30;
    homeButton.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
    homeButton.marginBottom = 10;
    homeButton.parent = chart.zoomControl;
    homeButton.insertBefore(chart.zoomControl.plusButton);

    // Center on the groups by default
    chart.homeZoomLevel = 1;
    chart.homeGeoPoint = { longitude: 5, latitude: 20 };

    chart.geodata = am4geodata_worldIndiaLow;

    // Create map polygon series
    const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.useGeodata = true;
    polygonSeries.exclude = ["AQ"];

    let mapPolygonTemplate = polygonSeries.mapPolygons.template;
    mapPolygonTemplate.events.on("over", function (event) {
      polygonSeries.mapPolygons.each(function (mapPolygon) {
        mapPolygon.isHover = true;
      });
      event.target.isHover = false;
      event.target.isHover = true;
    });

    // Set tooltip
    const polygonTemplate = polygonSeries.mapPolygons.template;

    polygonTemplate.adapter.add("tooltipHTML", (text, target) => {
      let data = target.tooltipDataItem.dataContext;
      if (target.tooltipDataItem.dataContext && !!data.value && data.value > 0) {
        return '<span className="d-flex align-items-center" style="font-size: 14px;">{name} <br/>{value} Shipments</span>';
      } else {
        return text;
      }
    });

    polygonSeries.tooltip.getFillFromObject = false;
    polygonSeries.tooltip.label.fill = "#000";
    polygonSeries.tooltip.background.fill = "#fff";
    polygonSeries.tooltip.background.stroke = "#eaecf0";

    // Set fill color based on data values
    polygonSeries.heatRules.push({
      property: "fill",
      target: polygonSeries.mapPolygons.template,
      min: am4core.color("#E2D9FC"),
      max: am4core.color("#5A1CE2"),
    });

    // Set data source
    polygonSeries.data = chartData;
    //remove amchart logo
    if (chart.logo) {
      chart.logo.disabled = true;
    }

    //changing mouse cursor
    mapPolygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;

    // Apply theme
    am4core.useTheme(am4themes_animated);

    // Return cleanup function
    return () => {
      chart.dispose();
    };
  }, [chartData]);
  return (
    <>
      <div id="chartdiv" className={styles.countryProfileChart} style={{ display: loading && "none" }} />
      {loading ? <LoadingSkeleton shape={"square"} height={"100%"} width={"100%"} margin={"1rem 1rem 0 0"} /> : null}
    </>
  );
};

export default CountryProfileChart;
